import { setGeneralDetails } from "Slices";
import { history } from ".";
const ChangeHistory = (action?: string, path?: string) => {
  document.body.className = "disabled";
  switch (action) {
    case "push":
      setGeneralDetails({
        screenClass: "fadeOutLeft",
      });
      setTimeout(() => {
        setGeneralDetails({
          screenClass: "",
        });
      }, 250);
      break;

    case "back":
      setGeneralDetails({
        screenClass: "fadeOutRight",
      });
      setTimeout(() => {
        setGeneralDetails({
          screenClass: "",
        });
      }, 250);
      break;

    default:
      break;
  }
  setTimeout(
    () => {
      const url = window.location.href;
      const breakUrl = url.split("?");
      const queryParams = breakUrl[1];
      const hasQueryParams = breakUrl.length > 1;
      const finalUrl = hasQueryParams ? `${path}?${queryParams}` : path ?? "";
      document.body.className = "";
      if (action === "push") {
        history.push(finalUrl);
      } else if (action === "blank") {
        window.open(finalUrl, "_self");
      } else if (action === "back") {
        if (path) {
          setGeneralDetails({
            screenClass: "fadeInLeft",
          });
          history.push(finalUrl);
        } else {
          history.goBack();
        }
      }
    },
    action === "blank" ? 0 : 250
  );
};

export default ChangeHistory;
